export default __webpack_public_path__ + "static/media/Group 3536.36887e7a.jpg";